export const EXPAND = "ABOUT_SERIES:SHOW_MORE:EXPAND";
export const COLLAPSE = "ABOUT_SERIES:SHOW_MORE:COLLAPSE";